import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const DatenschutzPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#121212] text-gray-200">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Button
          data-testid="datenschutz-back-btn"
          onClick={() => navigate(-1)}
          variant="ghost"
          className="text-gray-400 hover:text-white mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" /> Zurück
        </Button>

        <h1 data-testid="datenschutz-title" className="text-3xl sm:text-4xl font-bold text-white mb-8">
          Datenschutzerklärung
        </h1>

        <div className="space-y-8 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">1. Datenschutz auf einen Blick</h2>
            <h3 className="font-semibold text-white mb-2">Allgemeine Hinweise</h3>
            <p className="text-gray-300">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten
              passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
              persönlich identifiziert werden können.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">2. Verantwortliche Stelle</h2>
            <p className="text-gray-300">
              Allgaeu Travel & Transport E-GmbH<br />
              Stanko-Valchanov-Str. 5<br />
              9006 Varna<br />
              Support: Über den KI-gestützten Support in der App erreichbar (24/7)
            </p>
            <p className="text-gray-300 mt-2">
              Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit
              anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">3. Datenerfassung auf dieser Website</h2>

            <h3 className="font-semibold text-white mb-2 mt-4">Registrierung & Konto</h3>
            <p className="text-gray-300">
              Bei der Registrierung erheben wir: E-Mail-Adresse und ein verschlüsseltes Passwort.
              Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).
              Speicherdauer: Bis zur Kontolöschung durch den Nutzer.
            </p>

            <h3 className="font-semibold text-white mb-2 mt-4">Nutzungsdaten</h3>
            <p className="text-gray-300">
              Wir speichern Tipp-Käufe, Wettstatistiken und Chat-Verläufe zur Bereitstellung unserer Dienste.
              Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.
            </p>

            <h3 className="font-semibold text-white mb-2 mt-4">Push-Benachrichtigungen</h3>
            <p className="text-gray-300">
              Wenn Sie Push-Benachrichtigungen aktivieren, speichern wir Ihr Geräte-Token.
              Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung). Sie können die Einwilligung
              jederzeit in den Browser-Einstellungen widerrufen.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">4. Zahlungsabwicklung</h2>
            <p className="text-gray-300">
              Zahlungen werden über PayPal abgewickelt. Dabei werden Ihre Zahlungsdaten direkt an PayPal
              (Europe) S.à r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg, übermittelt.
              Wir erhalten lediglich eine Bestätigung der Zahlung, jedoch keine vollständigen Zahlungsdaten.
              Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.
            </p>
            <p className="text-gray-300 mt-2">
              PayPal Datenschutzerklärung:{' '}
              <a href="https://www.paypal.com/de/webapps/mpp/ua/privacy-full" className="text-[#00BFA6] underline" target="_blank" rel="noopener noreferrer">
                paypal.com/privacy
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">5. KI-Verarbeitung</h2>
            <p className="text-gray-300">
              Unsere KI-Analysefunktionen (Tipp-Generierung, Chat-Assistent, Support) nutzen externe
              KI-Dienste (OpenAI). Dabei können Anfragen und Kontext-Daten (anonymisiert) an diese
              Drittanbieter übertragen werden.
              Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.
            </p>
            <p className="text-gray-300 mt-2">
              Es werden keine persönlichen Daten (E-Mail, Name, Zahlungsdaten) an KI-Dienste weitergegeben.
              Lediglich anonymisierte Spiel- und Statistikdaten werden zur Analyse verwendet.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">6. Ihre Rechte (DSGVO)</h2>
            <div className="text-gray-300 space-y-2">
              <p><strong className="text-white">Auskunft (Art. 15):</strong> Sie haben das Recht, Auskunft über Ihre gespeicherten Daten zu erhalten.</p>
              <p><strong className="text-white">Berichtigung (Art. 16):</strong> Sie haben das Recht, unrichtige Daten berichtigen zu lassen.</p>
              <p><strong className="text-white">Löschung (Art. 17):</strong> Sie haben das Recht, die Löschung Ihrer Daten zu verlangen.</p>
              <p><strong className="text-white">Einschränkung (Art. 18):</strong> Sie können die Einschränkung der Verarbeitung verlangen.</p>
              <p><strong className="text-white">Datenübertragbarkeit (Art. 20):</strong> Sie haben das Recht, Ihre Daten in einem gängigen Format zu erhalten.</p>
              <p><strong className="text-white">Widerspruch (Art. 21):</strong> Sie können der Verarbeitung Ihrer Daten widersprechen.</p>
              <p><strong className="text-white">Widerruf (Art. 7 Abs. 3):</strong> Erteilte Einwilligungen können Sie jederzeit widerrufen.</p>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">7. Beschwerderecht</h2>
            <p className="text-gray-300">
              Ihnen steht ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
              Zuständige Aufsichtsbehörde in Datenschutzfragen ist der Landesdatenschutzbeauftragte
              des Bundeslandes, in dem unser Unternehmen seinen Sitz hat.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">8. SSL/TLS-Verschlüsselung</h2>
            <p className="text-gray-300">
              Diese Seite nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung.
              Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers
              von "http://" auf "https://" wechselt.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">9. Cookies</h2>
            <p className="text-gray-300">
              Diese Website verwendet ausschließlich technisch notwendige Cookies (z.B. für die Authentifizierung).
              Es werden keine Tracking-Cookies oder Analyse-Cookies von Drittanbietern eingesetzt.
              Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">10. Datenlöschung</h2>
            <p className="text-gray-300">
              Sie können jederzeit die Löschung Ihres Kontos und aller damit verbundenen Daten über
              den KI-Support in der App beantragen. Wir löschen Ihre Daten innerhalb von 30 Tagen,
              sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-center text-gray-500 text-xs">
          Stand: März 2026
        </div>
      </div>
    </div>
  );
};

export default DatenschutzPage;
